import { ItemDiagnostic, ItemDiagnosticAdapter } from "@/core/models/itemDiagnostic";
import { BuybackInCart } from "@/apps/shared/buyback/core/domain/model/buybackInCart/BuybackInCart";
import { DispatchCircuitRuleAdapter } from "@/core/models/dispatchCircuitRule";
import { CheckoutMethodsMapper } from "@/apps/shared/proposal/core/domain/mapper/checkoutMethodsMapper";
import { BuybackForm } from "@/apps/shared/buyback/view/forms/buybackForm";
import { ImpactPriceEntry } from "@/apps/shared/proposal/core/infrastructure/legacy/ImpactPriceEntry";

class BuybackInCartBuilder {
  buildFromBuybackForm(
    buybackForm: BuybackForm,
    diagnosticType: string,
    totalPrice: number,
    impactPriceEntries: ImpactPriceEntry[]
  ): BuybackInCart {
    const itemDiagnostic = new ItemDiagnostic();
    itemDiagnostic.productId = buybackForm.selectedProduct.id;
    itemDiagnostic.productLabel = buybackForm.selectedProduct.label;
    itemDiagnostic.productBrand = buybackForm.selectedProduct.brand;
    itemDiagnostic.productModele = buybackForm.selectedProduct.modele;
    itemDiagnostic.productEanCode = buybackForm.selectedProduct.eanCode;
    itemDiagnostic.productReference = buybackForm.selectedProduct.reference;
    itemDiagnostic.productWeight = buybackForm.selectedProduct.effectiveWeight;
    itemDiagnostic.productLength = buybackForm.selectedProduct.effectiveLength;
    itemDiagnostic.productWidth = buybackForm.selectedProduct.effectiveWidth;
    itemDiagnostic.productHeight = buybackForm.selectedProduct.effectiveHeight;
    itemDiagnostic.categoryId = buybackForm.selectedProduct.category.id;
    itemDiagnostic.categoryLabel = buybackForm.selectedProduct.category.label;
    itemDiagnostic.diagnosticType = diagnosticType;
    itemDiagnostic.responses = buybackForm.selectedResponses;
    itemDiagnostic.imei = buybackForm.imei;

    return new BuybackInCart(
      buybackForm.inCartId,
      buybackForm.selectedProduct.image,
      itemDiagnostic,
      buybackForm.getEstimatedPrice(),
      buybackForm.buybackOptions.getTransportMode()!,
      buybackForm.buybackOptions.getShippingMethod(),
      buybackForm.buybackOptions.getPaymentMode(),
      totalPrice,
      impactPriceEntries,
      null,
      buybackForm.getDeclarationId()
    );
  }

  buildFromParsedCartBuyback(parsedBuybackInCart: any): BuybackInCart {
    return new BuybackInCart(
      parsedBuybackInCart.inCartId,
      parsedBuybackInCart.cartItemImage,
      ItemDiagnosticAdapter.adaptDeepItemDiagnostic(parsedBuybackInCart.cartItem),
      parsedBuybackInCart.estimatedPrice,
      DispatchCircuitRuleAdapter.adapt(parsedBuybackInCart.transportMode),
      CheckoutMethodsMapper.mapCartShippingMethod(parsedBuybackInCart.shippingMethod),
      CheckoutMethodsMapper.mapCartPaymentMethod(parsedBuybackInCart.paymentMode),
      parsedBuybackInCart.totalPrice,
      parsedBuybackInCart.impactPriceEntries,
      parsedBuybackInCart.warehouseId,
      parsedBuybackInCart.declarationId
    );
  }
}

export default new BuybackInCartBuilder();
